import { useNavigate } from "react-router";
import TabsNav from "../../components/TabsNav";
import {
  ContentStyle,
  DataGridListStyle,
  Hints,
  HtmlTooltip,
} from "../../Theme";
import { v4 as uuid } from "uuid";
import { Grid, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import NoRecords from "../../components/NoRecords";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import ErrorOverlay from "../../components/ErrorOverlay";
import useFetch from "../../CustomHooks/useFetch";
import { LegacyHistoryData } from "../../Apis/AuthApiServices";
import { useEffect, useState } from "react";
import { DrugTextNTooltip, TextNTooltip } from "../../components/Content";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import HintIcon from "@mui/icons-material/FiberManualRecord";
import YSSnackBar from "../../uikit/YSSnackBar";
import { YSButton } from "../../uikit/YSButton";
import { PharmacyDetails } from "../NewRxPadSingle/PrescriptionSummary";

export default function LegacyHistory() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const Params = {
    pageNumber: page,
    patientId: sessionStorage.getItem("patientId"),
    pageSize: pageSize,
  };

  const { data, loading, error }: any = useFetch(Params, LegacyHistoryData, [
    page,
  ]);

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  const columnsLegacyMH: GridColDef[] = [
    {
      field: "description",
      headerName: "Drug Description",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: ({ row }) => (
        <DrugTextNTooltip
          row={row}
          onClick={() => {
            if (
              row.drugObsolete === false &&
              row.drugAvailable === true &&
              UserServiceState?.profileGroup !== 11
            ) {
              navigate("/newrxpad", {
                state: {
                  rowData: row,
                  key: "LEGACY",
                },
              });
            } else {
              SetStateData((prevState: any) => {
                return {
                  ...prevState,
                  message:
                    "You can't Populate Obsolete Drugs and Medication Not available.",
                  variant: "error",
                  open: true,
                };
              });
            }
          }}
          color={
            (row.drugObsolete || !row?.drugAvailable) &&
            UserServiceState?.profileGroup !== 11
              ? ""
              : "primary"
          }
          needPharmacy={false}
          showInactivationDetails={false}
          showPrintTooltip={false}
        />
      ),
    },
    {
      field: "sig",
      headerName: "SIG",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: ({ row }) => <TextNTooltip Text={row?.sig} />,
    },
    {
      field: "createdDt",
      headerName: "Date",
      type: "date",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
      renderCell: ({ row }) => (
        <Typography component="div" variant="body2">
          {row.obseletRx ? "" : row.createdDt}
        </Typography>
      ),
    },
    {
      field: "doctorName",
      headerName: "Physician",
      width: 140,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }: any) =>
        row?.doctorNpi ||
        row.prescriberAgentName ||
        row?.supervisorDoctorNpi ||
        row?.supervisorDoctorName ? (
          <>
            <Typography className={"textwrap"}>
              <Typography component="div" variant="body2">
                {[null, ""].includes(row?.doctorName)
                  ? "Not Available"
                  : row?.doctorName}{" "}
              </Typography>

              <HtmlTooltip
                placement="right"
                arrow
                title={<PhysicianDetails row={row} />}
              >
                <IconButton className="tooltip">
                  <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                </IconButton>
              </HtmlTooltip>
            </Typography>
          </>
        ) : (
          <>
            <Typography component="div" variant="body2">
              {[null, ""].includes(row?.doctorName)
                ? "Not Available"
                : row?.doctorName}{" "}
            </Typography>
          </>
        ),
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 220,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }: any) =>
        row?.pharmacyDetails ? (
          <>
            <Typography className="textwrap">
              <Typography component="div" variant="body2">
                {[null, ""].includes(row?.pharmacyDetails?.pharmacyName)
                  ? "Not Available"
                  : row?.pharmacyDetails?.pharmacyName}{" "}
              </Typography>
              <HtmlTooltip
                placement="right"
                arrow
                title={<PharmacyDetails row={row?.pharmacyDetails} />}
              >
                <IconButton className="tooltip">
                  <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                </IconButton>
              </HtmlTooltip>
            </Typography>
          </>
        ) : (
          <>
            <Typography component="div" variant="body2">
              Not Available
            </Typography>
          </>
        ),
    },
  ];

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  return (
    <>
      <TabsNav />
      <ContentStyle>
        <Grid
          container
          xs={12}
          spacing={0}
          alignItems="top"
          justifyContent="space-between"
          marginBottom={2}
        >
          <Typography
            variant="subtitle2"
            color={"primary"}
            component={"div"}
            fontWeight={600}
          >
            Legacy Medication History
          </Typography>
        </Grid>

        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle className={""}>
              <DataGrid
                autoHeight
                columns={columnsLegacyMH}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                disableSelectionOnClick
                getRowId={(row) => row.personDrugId ?? uuid()}
                headerHeight={36}
                rowHeight={40}
                loading={loading}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                paginationMode="server"
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                page={page}
                rows={data[0]?.items ?? []}
                rowsPerPageOptions={[20]}
                rowCount={rowCountState}
                sortingOrder={["asc", "desc", null]}
                getRowClassName={(params) => {
                  if (params.row.drugAvailable === false) {
                    return "FTP";
                  } else if (params.row.drugObsolete) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12} textAlign="center" className="btns">
            <YSButton
              onClick={() => {
                navigate("/medicationshistory");
              }}
              className=""
              children={"Back To Medication History"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
          <Grid>
            <Hints>
              {" "}
              <Typography
                component="label"
                variant="body2"
                fontWeight={600}
                className="ftp"
              >
                <HintIcon /> <div>Medication Not Available</div>
              </Typography>{" "}
              <Typography
                component="label"
                variant="body2"
                fontWeight={600}
                className="op"
              >
                <HintIcon /> <div>Obsolete Medication</div>
              </Typography>
            </Hints>
          </Grid>
        </Grid>

        <YSSnackBar
          message={StateData.message}
          variant={StateData.variant}
          open={StateData.open}
          handleClose={() => {
            SetStateData((prevState: any) => {
              return { ...prevState, open: false };
            });
          }}
        />
      </ContentStyle>
    </>
  );
}

const PhysicianDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      {row?.doctorName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Physician Name:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.doctorName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.doctorNpi && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prescriber NPI:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.doctorNpi}
            </Typography>
          </Grid>
        </>
      )}
      {row?.prescriberAgentName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Prescriber Agent Name:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.prescriberAgentName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.supervisorDoctorName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Supervisor Doctor Name:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.supervisorDoctorName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.supervisorDoctorNpi && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Supervisor Doctor NPI:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.supervisorDoctorNpi}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};
